import { StrapiPages } from "@lib/strapi/pages";
import {
  StrapiQuestionDTO,
  QuestionDTO,
} from "@lib/strapi/dtos/content-types/question.dto";
import { StrapiResponse } from "@lib/strapi/dtos/core/response.dto";
import { StrapiRoutes } from "@lib/strapi/routes";
import { fetchAPI } from "@lib/strapi/fetch-api";
import { markdownToPlainText, parseStrapiContent } from "@lib/strapi/content";

export class QuestionService {
  static async fromStrapi(
    dto: QuestionDTO,
    locale: string,
    strapiData?: StrapiQuestionDTO,
  ): Promise<QuestionDTO> {
    if (!strapiData) {
      return null;
    }
    if (dto == null) {
      dto = new QuestionDTO();
    }
    dto.documentId = strapiData.documentId;
    dto.question = strapiData.question;
    dto.answer = await parseStrapiContent(strapiData.answer);
    dto.answerText = markdownToPlainText(strapiData.answer);
    dto.displayOrderIndex = strapiData.displayOrderIndex;
    dto.category = strapiData.category;
    dto.featuredOnHomepage = strapiData.featuredOnHomepage;
    return dto;
  }

  static async fetchAll(
    authToken: string,
    locale: string,
  ): Promise<QuestionDTO[]> {
    const token = (process.env.CMS_API_TOKEN || process.env.STRAPI_API_TOKEN);
    const urlParamsObject = {
      locale,
      sort: ["displayOrderIndex:asc"],
      pagination: { pageSize: 200 },
    };
    const response: StrapiResponse<StrapiQuestionDTO[]> = await fetchAPI(
      StrapiRoutes.questions(),
      urlParamsObject,
      token,
    );
    const dto = new QuestionDTO();
    return await Promise.all(
      (response.data ?? []).map(
        async (item) =>
          await QuestionService.fromStrapi(new QuestionDTO(), locale, item),
      ),
    );
  }

  static async fetchHomepage(
    authToken: string,
    locale: string,
  ): Promise<QuestionDTO[]> {
    const token = (process.env.CMS_API_TOKEN || process.env.STRAPI_API_TOKEN);
    const urlParamsObject = {
      locale,
      filters: { featuredOnHomepage: true },
      sort: ["displayOrderIndex:asc"],
      pagination: { pageSize: 50 },
    };
    const response: StrapiResponse<StrapiQuestionDTO[]> = await fetchAPI(
      StrapiRoutes.questions(),
      urlParamsObject,
      token,
    );
    const dto = new QuestionDTO();
    return await Promise.all(
      (response.data ?? []).map(
        async (item) =>
          await QuestionService.fromStrapi(new QuestionDTO(), locale, item),
      ),
    );
  }
}
